<div class="component-liste-patients__container" [ngClass]="{'mobileViewForce': mobileViewForce}">
	<div class="component-liste-patients__header">
		<lua-tableau-entete [triee]=false entete="PATIENT" position="left">
		</lua-tableau-entete>
		<lua-tableau-entete [triee]=false entete="AGE" position="left">
		</lua-tableau-entete>
		<lua-tableau-entete [triee]=false entete="TELEPHONE" position="left">
		</lua-tableau-entete>
	</div>
	<di-ligne-patient *ngFor="let patient of patients" [patient]="patient" (onClickLigne)="onClick(patient._id)"
		[mobileViewForce]="mobileViewForce"></di-ligne-patient>
</div>